import React from 'react';

/**
 * CheckboxInput - Single checkbox input (for boolean values)
 * 
 * @param {Object} props
 * @param {Object} props.feature - Feature object from RuleEngine
 * @param {*} props.value - Current checked state
 * @param {Function} props.onChange - Change handler
 * @param {boolean} props.disabled - Whether input is disabled
 * @param {string} props.className - Additional CSS classes
 */
const CheckboxInput = ({ feature, value, onChange, disabled = false, className = '' }) => {
    const displayText = feature?.property?.displayText || feature?.name || 'Option';
    const isChecked = value === true || value === 'true' || value === 'yes' || value === '1';
    
    const handleChange = (e) => {
        // Always return true/false for consistency
        onChange({ target: { value: e.target.checked } });
    };
    
    return (
        <label 
            className={`checkbox-input-wrapper ${className}`}
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.6 : 1,
            }}
        >
            <input
                type="checkbox"
                checked={isChecked}
                onChange={handleChange}
                disabled={disabled}
                style={{
                    width: '18px',
                    height: '18px',
                    accentColor: 'var(--accent)',
                    cursor: disabled ? 'not-allowed' : 'pointer'
                }}
            />
            <span style={{ fontSize: '0.9rem', fontWeight: 500 }}>
                {displayText}
            </span>
            {feature?.property?.description && (
                <span 
                    style={{
                        fontSize: '0.75rem',
                        color: 'var(--text-secondary)',
                        fontStyle: 'italic'
                    }}
                >
                    - {feature.property.description}
                </span>
            )}
        </label>
    );
};

export default CheckboxInput;
